// lib/useAuthSync.js
import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export function useAuthSync() {
  const router = useRouter()

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'logout_event') {
        const user = localStorage.getItem('user')
        if (!user) {
          console.error("User Sign-out: User not found in storage change pushing to signin")
          router.replace('/agency/signin')
        }
      }
    }

    window.addEventListener('storage', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [router])
}
